// ** React Imports
import { createContext, useState } from 'react'
import PropTypes from 'prop-types';

// ** Create Context
export const AppBarContext = createContext({
    title: undefined,
    setTitle: (/** @type {any} */ _) => {_}
})

export const AppBarContextProvider = ({ children }) => {
    // ** State
    const [title, setTitle] = useState();
    
    return <AppBarContext.Provider value={{ title, setTitle }}>{children}</AppBarContext.Provider>
}

AppBarContextProvider.propTypes = {
    children: PropTypes.element
}

export const UserConsumer = AppBarContext.Consumer
